import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../custom/StateProvider';
import _ from 'lodash';
import {API} from "../../../config";
import Utils from "../../custom/utils";
import {connect} from "react-redux";
import Typography from '@material-ui/core/Typography';
import {FusePageSimple} from '@fuse';
import classNames from 'classnames';
import AccountJournalButton from "./components/accountJournalButton";
import EditJournalButton from "./components/editJournalButton";
import WalletBalance from "./components/walletBalance";
import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

const banks = API.service('banks');
const bank_accounts = API.service('bank-accounts');

const moment = require('moment');

const headerHeight = 60;

const styles = theme => ({
  root                    : {},
  avatar                  : {},
  layoutHeader            : {
    height   : headerHeight,
    minHeight: headerHeight
  },
  layoutLeftSidebar       : {
    width: '400px',
    marginBottom:'50px'
  },
  addButton               : {
    position: 'absolute',
    right   : 12,
    bottom  : 12,
    zIndex  : 99
  },
  tabs:{
    display:'inline-block',
    width:'100%',
    borderBottom:'2px solid #6a94ff',
    marginLeft:0,
    paddingLeft:0,
    textTransform:'capitalize',

    '& li':{
      display:'inline-block',

      '& button':{
        margin:'1px',
        padding:'6px 12px',
        backgroundColor:'#383c42',
        color:'white',
        textTransform:'capitalize',
      },
      '& button:hover':{
        backgroundColor:'#6a94ff',
      },
      '& button.active':{
        backgroundColor:'#6a94ff',
      }
    }
  },
  bankTable:{
    width:'100%',
  },
  tableHeader:{
    fontWeight:'bold',

    '& td':{
      padding:'10px'
    }
  },
  tablerows:{
    '&:nth-of-type(2n)':{
      backgroundColor:'rgba(0,0,0,0.2)'
    },
    '& td':{
      padding:'10px'
    },
    '& .editbutton':{
      minHeight:'0px',
      padding:'0px',
      display:'none'
    },

    '&:hover .editbutton':{
      display:'block'
    }
  },
  flex: {
    flex: 1,
  },
  filterField:{
    padding:'7px',
    borderRadius:'5px',
    marginLeft:'5px'
  },
  redButton: {
    color: theme.palette.getContrastText(red[500]),
    backgroundColor: red[500],
    '&:hover': {
      backgroundColor: red[700],
    },
  },
  fixedheader:{
    position:'fixed',
    width:'100%',
    paddingLeft:'250px',
    top:'60px'
  }
});

class Reconciliation extends Component {
    state = {
        accounts: [],
        activeTab: "account_1",
        records:[],
        account:1,
        checked:{},
        start_type:"date",
    }

    balance = 0;

    componentDidMount = () => {
      this.getAccounts();
    };

    getAccounts = () => {
      banks.find().then(b=>{
        let bankData = {};
        b.data.forEach((v,i)=>{
          bankData[v._id] = v;
        });
        this.setState({
          accounts:bankData
        })
      })
    }

    changeTab = (e) => {
      //var account = e.target.id
      this.setState({
        activeTab:e.target.id,
        account:e.target.id.replace('account_','')
      },()=>{
        this.updateRecords()
      })
    }

    updateRecords = () => {
      bank_accounts.find({query:{_bank_account: this.state.account,_deleted:{$ne:true},$sort:{_timestamp:1}}}).then(a=>{
        console.log(a);
        this.setState({
          records:a.data,
        })
      }).catch(e =>{
        console.log(e);
      })
    }

    getAmountWithCurrency(amount, currencyType){
        let currency = Utils.getCurrency(currencyType.toUpperCase());
        return (currency.currency_symbol + Utils.addThousandCommasTwoDec(amount, '0,0.00').toString())
    }

  handleChange = (event) => {

    var checked = this.state.checked;
    checked[event.target.name] = event.target.checked;
    this.setState({
      checked:checked,
    });
  }

  saveRec = () => {
      const app = this;
      let recKey = 0;
      let record = {};
      let recDate = moment().utc();
      let checked = {...this.state.checked};

      let numChecked = _.size(checked);
      let i=0;
      Object.keys(this.state.checked).forEach(k=>{
        recKey = k.replace("_checked","");
        record = this.state.records[recKey];
        bank_accounts.patch(record.id, {_reconcilled:recDate}, {query:{id:record.id,$limit:1}}).then(r=>{
          checked[k] = false;
          app.setState({
            checked:checked
          });
          i++;
          if(i >= numChecked){
            app.updateRecords();
          }
        })
      })
  };

  componentWillReceiveProps(nextProps) {
      if(nextProps.context.updateRecords === true){
        this.props.context.update({
          updateRecords:false,
        });

        this.updateRecords();
      }

      if( this.props.user.role === 'unauthenticated' && nextProps.user.role !== 'unauthenticated'){
        this.getAccounts();
        this.updateRecords();
      }
  }

  handleFieldChange = (event) => {
    this.setState(_.set({ ...this.state, error: '' }, event.target.name, event.target.type === 'checkbox' ? event.target.checked : event.target.value));
  }

  render() {
    const { classes } = this.props;
    const { accounts } = this.state;
    return (
      <FusePageSimple
        className={classes.root}
        classes={{
          root              : classes.layoutRoot,
          contentCardWrapper: classes.layoutContentCardWrapper,
          leftSidebar       : classes.layoutLeftSidebar,
          header            : classes.layoutHeader
        }}
        header={
          <div className={classNames("flex flex-1 flex-col sm:flex-row items-center justify-between p-24")}>
            <Typography variant="title" color="inherit" className={"flex-1"}>
              Account Reconciliation
            </Typography>
            {(this.props.user.role.includes('super') || this.props.user.role.includes('investor_creation')) &&
              <React.Fragment>
                <b>Start At:</b>&nbsp;&nbsp;&nbsp;
                <input type={'radio'} name="start_type" onChange={this.handleFieldChange} checked={(this.state.start_type === 'date')} value={'date'}/>&nbsp; Date &nbsp;&nbsp;
                <input type={'radio'} name="start_type" onChange={this.handleFieldChange} checked={(this.state.start_type === 'prev')} value={'prev'} />&nbsp; Previous Rec. &nbsp;&nbsp;
                <input type={'radio'} name="start_type" onChange={this.handleFieldChange} checked={(this.state.start_type === 'recs')} value={'recs'} />&nbsp; Rec. Period. &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                {(this.state.start_type ==='date') &&
                  <React.Fragment>
                    Date:
                    <input className={classes.filterField} type={'date'} value={'2018-01-01'} />&nbsp;-&nbsp;End Date:<input className={classes.filterField} type={'date'} /> &nbsp;
                    <Button className={classes.debutton} variant="contained" color="primary">Filter</Button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </React.Fragment>
                }
                {(this.state.start_type ==='recs') &&
                <React.Fragment>
                  Rec. Period:
                  &nbsp;&nbsp;<Select
                    value={this.state.journal_type}
                    onChange={this.handleFieldChange}
                    inputProps={{
                      name: 'journal_type',
                      id: 'journal_type',
                    }}
                  >
                    <MenuItem value={'2019-08-16'}>2019-08-16</MenuItem>
                    <MenuItem value={'2019-09-04\t'}>2019-09-04</MenuItem>
                  </Select> &nbsp;
                  <Button className={classes.debutton} variant="contained" color="primary">Filter</Button> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                </React.Fragment>
                }
              <AccountJournalButton currentAccount={this.state.account} updateRecords={() => this.updateRecords}/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<Button className={classes.redButton} variant="contained" color="primary" onClick={this.saveRec}>Save Rec.</Button>
              </React.Fragment>
            }
          </div>
        }
        content={
          <div className={classes.sectionHeader} style={{position:'relative',padding: '5px', marginTop:'6px'}}>
            {(this.state.accounts.length !== {}) &&
            <ul className={classes.tabs}>
              {
                //this.state.accounts.map((v, i) => {
                Object.keys(accounts).map( (key)=>{
                  return (
                    <li key={key}>
                      <button className={(this.state.activeTab === ("account_" + key)) ? 'active' : ''}
                              onClick={this.changeTab}
                              id={"account_" + key}>{accounts[key].beneficiary_account_number} {accounts[key].type} ({accounts[key].currency})</button>
                    </li>
                  )
                })
              }

            </ul>
            }
            <table className={classes.bankTable} cellSpacing={0} cellPadding={0}>
              <thead>
                <tr className={classes.tableHeader}>
                  <td>&nbsp;</td>
                  <td>Date</td>
                  <td>Description</td>
                  <td>Type</td>
                  <td>Client Ref.</td>
                  <td>Notes</td>
                  <td>Amount</td>
                  <td>Balance</td>
                  <td>Investor Wallet</td>
                  <td>Reconciled</td>
                  <td width="120px">Actions</td>
                </tr>
              </thead>
              {(this.state.records.length > 0) &&
              <tbody>
              {this.state.records.map((data, key) => {
                this.balance = (key === 0) ? 0 : this.balance + parseFloat(data._fund);
                return (
                  <tr key={key} className={classes.tablerows}
                      style={{backgroundColor: (this.state.checked[key + '_checked']) ? 'rgba(0,255,0,0.2)' : ''}}>
                    <td>{(data._reconcilled) &&
                    <input type={'checkbox'} checked={true} disabled name={key + '_checked'} id={key + '_checked'}/>
                    }
                      {(!data._reconcilled) &&
                      <input type={'checkbox'} onChange={this.handleChange} name={key + '_checked'}
                             id={key + '_checked'}/>
                      }
                    </td>
                    <td>{moment(data._timestamp).format('YYYY-MM-DD')}</td>
                    <td>{data._comment}</td>
                    <td>{data._type}</td>
                    <td>{data._reference_id}</td>
                    <td>{data._notes}</td>
                    <td style={{textAlign: 'right'}}>{Utils.addThousandCommasTwoDec(data._fund, '0,0.00')}</td>
                    <td style={{
                      textAlign: 'right',
                      color: (data._reconcilled) ? 'green' : 'inherit'
                    }}>{Utils.addThousandCommasTwoDec(this.balance, '0,0.00')}</td>
                    <td style={{textAlign: 'right'}}><WalletBalance timestamp={data._timestamp} currentAccount={accounts[this.state.account]}/></td>
                    <td>{(data._reconcilled) ? moment(data._reconcilled).format('YYYY-MM-DD') : ''}</td>
                    <td>{(!data._reconcilled) ? <EditJournalButton currentAccount={this.state.account} record={data}/> : ''}</td>
                  </tr>
                )
              })
              }
              </tbody>
              }
            </table>
          </div>
        }
      />
    )
  }
}
function mapStateToProps({ fuse, auth }) {
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(Reconciliation))));
